import Products from "./components/Products";
import Register from "./components/Register";
import Login from "./components/Login";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";
//import ipConfig from "./ipConfig.json";
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { Route, Switch } from "react-router-dom";
//import { Check } from "@mui/icons-material";

export const config = {
  endpoint: `https://qkart-frontend-xu5p.onrender.com/api/v1`,
};

function App() {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route exact path="/" component={Products} />
          <Route path="/register" component={Register} />
          <Route path="/login" component={Login} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/thanks" component={Thanks} />
        </Switch>
      </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
